const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaAgrupado: [],
	listaHistoricos: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'SOLICITACAO_COMPRA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'SOLICITACAO_COMPRA_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'SOLICITACAO_COMPRA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};
		
		case 'SOLICITACAO_COMPRA_AGRUPADO_LISTADO':
            return {
				...state,
				listaAgrupado: action.payload.data
			};

		case 'SOLICITACAO_HISTORICO_LISTADO':
            return {
				...state,
				listaHistoricos: action.payload.data
			};

        default:
            return state;
    }
}
